import { api } from '../../services/api';
import { DefaulterNotice } from './types';

export const getDefaulterNotice = async (): Promise<DefaulterNotice> => {
  const response = await api.get('/customer/defaulter-notice');
  return response.data.data;
};

export const acknowledgeDefaulterNotice = async (): Promise<void> => {
  await api.post('/customer/defaulter-notice/ack');
};
